<template>
  <div class="gs-app gs-refresh-controls gv-integration-form">
    <div class="form-content-box">
      <div class="font-semibold text-sm text-grey-700 mb-1">
        {{ $t('frontend_groovewebinar_select_list') }}
      </div>
      <div class="pink-treeselect w-full">
        <treeselect
          :key="1"
          class="h-10 custom-treeselect mb-4"
          v-model="selectedLists"
          :multiple="true"
          :options="lists"
          :closeOnSelect="closeOnSelect"
          :clearable="clearable"
          @select="listSelected"
          :clearOnSelect="clearOnSelect"
          :placeholder="
            this.$t('frontend_groovewebinar_select_list_placeholder')
          "
        />
      </div>
    </div>
     <div class="form-content-box">
        <div class="font-semibold text-sm text-grey-700 mb-1">
          {{ $t('frontend_groovewebinar_select_tag') }}
        </div>
        <div class="pink-treeselect w-full">
          <treeselect
            :key="1"
            class="h-10 custom-treeselect mb-4"
            v-model="selectedTags"
            :multiple="true"
            :options="tags"
            :closeOnSelect="closeOnSelect"
            :clearable="clearable"
            @select="tagSelected"
            :clearOnSelect="clearOnSelect"
            :placeholder="
              this.$t('frontend_groovewebinar_select_tag_placeholder')
            "
          />
        </div>
      </div>
     <div class="form-content-box">
      <div class="font-semibold text-sm text-grey-700 mb-1">
        {{ $t('frontend_groovewebinar_select_sequence') }}
      </div>
      <div class="pink-treeselect w-full">
        <treeselect
          :key="1"
          class="h-10 custom-treeselect mb-4"
          v-model="selectedSequences"
          :multiple="true"
          :options="sequences"
          :closeOnSelect="closeOnSelect"
          :clearable="clearable"
          @select="sequenceSelected"
          :clearOnSelect="clearOnSelect"
          :placeholder="
            this.$t('frontend_groovewebinar_select_sequence_placeholder')
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import themeConfig from '@/theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'AddList',
  props: {
    model: {
      required: true,
    },
    lists: {
      required: true,
      defaut: []
    },
    selectedList: {
      required: true,
    },
    tags: {
      required: true,
      defaut: []
    },
    selectedTag: {
      required: true,
    },
    sequences: {
      required: true,
      defaut: []
    },
    selectedSequence: {
      required: true,
    },
    eventId: {
      required: true,
    },
    eventType: {
      required: true,
    },
    optinId: {},
  },
  data() {
    return {
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      selectionSubmitted: false,
      isListSelectionInvalid: false,
      localModel: this.model,
      selectedLists: this.selectedList,
      selectedTags: this.selectedTag,
      selectedSequences: this.selectedSequence
    };
  },

  computed: {
    // listData() {
    //   const listData = [];
    //   // let listIndex = listData.findIndex((listEle) => {
    //   //   return listEle.id === 'createListOption1';
    //   // });
    //   // if (listIndex < 0) {
    //   //   listData.push({
    //   //     id: 'createListOption1',
    //   //     label: this.$t('frontend_groovemail_mail_list_newlist'),
    //   //   });
    //   // }
    //   return listData;
    // },
  },

  components: {
    Treeselect,
    Loading
  },
  async created() {},

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
    listSelected(node) {
      this.validateListAdded();
    },
    tagSelected(node) {
      this.validateListAdded();
    },
    sequenceSelected(node) {
      this.validateListAdded();
    },
    async save(event, id = 0) {
      this.showLoader();
      const selectedIntegrations = [];
      const self = this;

      if(this.selectedLists){
        await this.selectedLists.forEach((list) => {
        const integration = {};
        integration.video_id = self.model.id;
        integration.integration_type = 'list';
        integration.integration_id = list;
        integration.optinId = this.optinId;
        integration.event_slug = id ? event+'_'+id : event;
        integration.event_type = id ? 'dynamic' : 'static';

        selectedIntegrations.push(integration);
      });
      }

      if(this.selectedTags){
        await this.selectedTags.forEach((tag) => {
        const integration = {};
        integration.video_id = self.model.id;
        integration.integration_type = 'tag';
        integration.integration_id = tag;
        integration.optinId = this.optinId;
        integration.event_slug = id ? event+'_'+id : event;
        integration.event_type = id ? 'dynamic' : 'static';

        selectedIntegrations.push(integration);
      });
      }
      
      if(this.selectedSequences){
        await this.selectedSequences.forEach((sequence) => {
        const integration = {};
        integration.video_id = self.model.id;
        integration.integration_type = 'sequence';
        integration.integration_id = sequence;
        integration.optinId = this.optinId;
        integration.event_slug = id ? event+'_'+id : event;
        integration.event_type = id ? 'dynamic' : 'static';

        selectedIntegrations.push(integration);
      });
      }

      if(selectedIntegrations.length == 0) {
        selectedIntegrations.push({
          integration_type: null,
          event_slug: id ? event+'_'+id : event,
          event_type: id ? 'dynamic' : 'static',
        });
        console.log(selectedIntegrations);
      }
      
      const integrations = await this.model
        .mailIntegration()
        .attach(selectedIntegrations);

      this.hideLoader();
    },

    validateListAdded() {
      if (this.localModel.assignlists && this.localModel.assignlists.length) {
        this.isListSelectionInvalid = false;
      } else {
        this.isListSelectionInvalid = true;
      }
    },

    validate() {
      this.selectionSubmitted = true;
      return true;
    },
  },
};
</script>

<style lang="scss">
.form-setup-radio.flex {
  margin: 0;
  padding: 0;
  border: none;
  height: auto;
  position: relative;
  .ml-2 {
    margin: 0;
    label {
      color: #191d3a;
    }
    .text-grey-500 {
      font-size: 14px;
      line-height: 24px;
      color: #545671;
      margin-top: 8px;
    }
  }
  .w-6 {
    height: 24px;
    margin: 0;
    position: absolute;
    right: 0;
    top: 16px;
  }
}

.pink-treeselect .vue-treeselect__control {
  border-color: #dcdcea !important;
}
.pink-treeselect .vue-treeselect__multi-value-item,
.pink-treeselect .vue-treeselect__icon {
  background-color: #fd6481;
  color: #fff;
}
.pink-treeselect .vue-treeselect__checkbox--checked {
  border-color: #fd6481;
  background: #fd6481;
}
.pink-treeselect
  .vue-treeselect__label-container:hover
  .vue-treeselect__checkbox--checked {
  border-color: #fd6481;
  background: #fd6481;
}
.pink-treeselect
  .vue-treeselect__label-container:hover
  .vue-treeselect__checkbox--unchecked {
  border-color: #fd6481;
  background: #fff;
}
</style>

<style>
.gv-integration-form { padding: 20px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); }
@media (max-width: 640px) { .gv-integration-form { padding: 16px; } }
</style>
